const statusMessages = {
  400: '请求内容不正确，请检查后重试', 401: '登录已过期或尚未登录，请重新登录',
  403: '没有权限执行此操作，请联系管理员', 404: '没有找到对应记录，请刷新后重试',
  405: '不支持此操作方式', 409: '数据状态已变化，请刷新后重试',
  413: '上传内容过大，请缩小文件后重试', 422: '提交内容格式不正确，请检查必填项和数值',
  429: '操作过于频繁，请稍后重试', 500: '服务暂时异常，请稍后重试',
  502: '外部服务暂未确认结果，请稍后核对原记录，勿重复提交',
  503: '服务暂不可用，请稍后重试', 504: '请求处理超时，请先核对原记录再重试'
}
const known = { 'Token expired': '登录已过期，请重新登录', 'Invalid token': '登录信息无效，请重新登录',
  'Missing token': '请先登录后再操作', 'Not authenticated': '请先登录后再操作',
  'Account disabled': '账号已停用，请联系管理员', 'Not Found': '没有找到对应页面或记录' }

export function chineseText(value, fallback = '操作未完成，请稍后重试') {
  if (typeof value !== 'string') return fallback
  return known[value] || (/[\u4e00-\u9fff]/.test(value) ? value : fallback)
}

export function apiErrorMessage(error, fallback = '操作失败，请稍后重试') {
  const detail = error?.response?.data?.detail
  const value = typeof detail === 'string' ? detail : detail?.message
  if (!error?.response) return chineseText(error?.message, '网络连接中断或请求超时，请检查网络并核对原记录后重试')
  return chineseText(value, statusMessages[error.response.status] || fallback)
}

export function normalizeApiError(error) {
  const message = apiErrorMessage(error)
  error.message = message
  if (error.response) {
    const data = error.response.data
    const detail = data?.detail
    error.response.data = { ...(data && typeof data === 'object' && !Array.isArray(data) ? data : {}),
      detail: detail && typeof detail === 'object' && !Array.isArray(detail) ? { ...detail, message } : message }
  }
  return error
}
